import { AppState } from "@Safemate/Store/types";

export const selectCustomerTree = ({subUnits: {customer: {customerTree}}}: AppState) => customerTree;
export const selectCustomers = ({subUnits: {customer: {customers}}}: AppState) => customers;

